var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.APPROVAL.POPUP.TITLE")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("table", { staticClass: "create_table noLine" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBJECT"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", { staticClass: "clearable" }, [
                      _c("input", {
                        directives: [
                          { name: "clearable", rawName: "v-clearable" },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.approvalSubject,
                            expression: "approvalSubject"
                          }
                        ],
                        staticClass: "text_input w100p",
                        attrs: { type: "text" },
                        domProps: { value: _vm.approvalSubject },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.approvalSubject = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.APPROVAL.POPUP.CLASS3")))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("fieldset", { staticClass: "ui_fieldset" }, [
                      _c("label", { staticClass: "serach-wrap w40p" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.emailAddressesCL3,
                              expression: "emailAddressesCL3"
                            }
                          ],
                          staticClass: "text_input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.emailAddressesCL3 },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.stopPropagation()
                              return _vm.emailAddressFind(
                                _vm.emailAddressesCL3,
                                "CL3",
                                "SEARCH"
                              )
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.emailAddressesCL3 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "in_btn_search",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.emailAddressFind(
                                  _vm.emailAddressesCL3,
                                  "CL3",
                                  "SEARCH"
                                )
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "ico_input_serach" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr_only" })
                          ]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm.$t("FIELD.APPROVAL.POPUP.APPROVELIST"))
                    ),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("fieldset", { staticClass: "ui_fieldset" }, [
                      _c("label", { staticClass: "serach-wrap w40p" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.emailAddresses,
                              expression: "emailAddresses"
                            }
                          ],
                          staticClass: "text_input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.emailAddresses },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.stopPropagation()
                              return _vm.emailAddressFind(
                                _vm.emailAddresses,
                                "",
                                "SEARCH"
                              )
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.emailAddresses = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "in_btn_search",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.emailAddressFind(
                                  _vm.emailAddresses,
                                  "",
                                  "SEARCH"
                                )
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "ico_input_serach" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr_only" })
                          ]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "noLine" }, [
                  _c("td", { attrs: { colspan: "2" } }, [
                    _c("dl", { staticClass: "approve_wrap" }, [
                      _c("dt", [
                        _c("fieldset", { staticClass: "radio-items" }, [
                          _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.checkApproval,
                                  expression: "checkApproval"
                                }
                              ],
                              staticClass: "only-sr checked",
                              attrs: {
                                id: "b10",
                                type: "radio",
                                name: "temp0",
                                value: "1"
                              },
                              domProps: {
                                checked: _vm._q(_vm.checkApproval, "1")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pathModify("approval")
                                },
                                change: function($event) {
                                  _vm.checkApproval = "1"
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                style: _vm.getApprovalStyle(),
                                attrs: { for: "b10" }
                              },
                              [_vm._v(_vm._s(_vm.$t("TITLE.GLOBAL.APPROVAL")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.checkApproval,
                                  expression: "checkApproval"
                                }
                              ],
                              staticClass: "only-sr",
                              attrs: {
                                id: "b20",
                                type: "radio",
                                name: "temp0",
                                value: "2"
                              },
                              domProps: {
                                checked: _vm._q(_vm.checkApproval, "2")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pathModify("consent")
                                },
                                change: function($event) {
                                  _vm.checkApproval = "2"
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                style: _vm.getConsentStyle(),
                                attrs: { for: "b20" }
                              },
                              [_vm._v(_vm._s(_vm.$t("TITLE.GLOBAL.CONSENT")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.checkApproval,
                                  expression: "checkApproval"
                                }
                              ],
                              staticClass: "only-sr",
                              attrs: {
                                id: "b30",
                                type: "radio",
                                name: "temp0",
                                value: "9"
                              },
                              domProps: {
                                checked: _vm._q(_vm.checkApproval, "9")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pathModify("notification")
                                },
                                change: function($event) {
                                  _vm.checkApproval = "9"
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                style: _vm.getNotificationStyle(),
                                attrs: { for: "b30" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("TITLE.GLOBAL.NOTIFICATION"))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("input", {
                              staticClass: "only-sr",
                              attrs: {
                                id: "b40",
                                type: "radio",
                                name: "temp0",
                                disabled: _vm.isDisable
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pathModify("parallelApproval")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                style: {
                                  backgroundColor: _vm.isDisable
                                    ? "#fff"
                                    : "#b3b3b3",
                                  color: _vm.isDisable ? "#b3b3b3" : "#fff"
                                },
                                attrs: { for: "b40" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("TITLE.GLOBAL.PARALLELAPPROVAL")
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("input", {
                              staticClass: "only-sr",
                              attrs: {
                                id: "b50",
                                type: "radio",
                                name: "temp0",
                                disabled: _vm.isDisable
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pathModify("parallelConsent")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                style: {
                                  backgroundColor: _vm.isDisable
                                    ? "#fff"
                                    : "#b3b3b3",
                                  color: _vm.isDisable ? "#b3b3b3" : "#fff"
                                },
                                attrs: { for: "b50" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("TITLE.GLOBAL.PARALLELCONSENT"))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("input", {
                              staticClass: "only-sr",
                              attrs: {
                                id: "b60",
                                type: "radio",
                                name: "temp0",
                                disabled: _vm.isDisable
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pathModify("relieve")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                style: {
                                  backgroundColor: _vm.isDisable
                                    ? "#fff"
                                    : "#b3b3b3",
                                  color: _vm.isDisable ? "#b3b3b3" : "#fff"
                                },
                                attrs: { for: "b60" }
                              },
                              [_vm._v(_vm._s(_vm.$t("TITLE.GLOBAL.RELIEVE")))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("article", { staticClass: "app_btn" }, [
                          _c("span", {
                            staticClass: "button-ctrl_first",
                            on: {
                              click: function($event) {
                                return _vm.pathMove("first")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "button-ctrl_prev",
                            on: {
                              click: function($event) {
                                return _vm.pathMove("prev")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "button-ctrl_next",
                            on: {
                              click: function($event) {
                                return _vm.pathMove("next")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "button-ctrl_last",
                            on: {
                              click: function($event) {
                                return _vm.pathMove("last")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "button-ctrl_del",
                            on: {
                              click: function($event) {
                                return _vm.pathModify("delete")
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("dd", { staticClass: "scroll" }, [
                        _c(
                          "ul",
                          _vm._l(_vm.approvalPath, function(item) {
                            return _c(
                              "li",
                              {
                                key: item.aplSort + _vm.approvalPathKey,
                                class: item.aplnActive,
                                style:
                                  "DefaultAplnUser" == item.enDiscription
                                    ? "pointer-events: none"
                                    : "",
                                attrs: { id: item.aplSort },
                                on: {
                                  click: function($event) {
                                    return _vm.getActive(
                                      $event,
                                      "li",
                                      item.aplSort,
                                      item.aplnRole
                                    )
                                  }
                                }
                              },
                              [
                                "0" === item.aplnRole ||
                                "4" === item.aplnRole ||
                                "7" === item.aplnRole
                                  ? _c(
                                      "fieldset",
                                      {
                                        staticClass: "radio-items",
                                        staticStyle: { width: "100%" }
                                      },
                                      [
                                        "0" === item.aplnRole
                                          ? _c("div", [
                                              _c("input", {
                                                staticClass: "only-sr",
                                                attrs: {
                                                  type: "radio",
                                                  id: "radio0_" + item.aplnSeq,
                                                  name: "radio_" + item.aplnSeq
                                                },
                                                domProps: {
                                                  checked: _vm.getChecked(
                                                    "0",
                                                    item.aplnRole
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for:
                                                      "radio0_" + item.aplSort
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BUTTON.GLOBAL.REGISTER"
                                                        )
                                                      ) +
                                                      "\n                                                            "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        "4" === item.aplnRole
                                          ? _c("div", [
                                              _c("input", {
                                                staticClass: "only-sr",
                                                attrs: {
                                                  type: "radio",
                                                  id: "radio4_" + item.aplSort,
                                                  name: "radio_" + item.aplSort
                                                },
                                                domProps: {
                                                  checked: _vm.getChecked(
                                                    "4",
                                                    item.aplnRole
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for:
                                                      "radio4_" + item.aplSort
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                               \t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "TITLE.GLOBAL.PARALLELCONSENT"
                                                        )
                                                      ) +
                                                      "\n                                                            "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        "7" === item.aplnRole
                                          ? _c("div", [
                                              _c("input", {
                                                staticClass: "only-sr",
                                                attrs: {
                                                  type: "radio",
                                                  id: "radio7_" + item.aplSort,
                                                  name: "radio_" + item.aplSort
                                                },
                                                domProps: {
                                                  checked: _vm.getChecked(
                                                    "7",
                                                    item.aplnRole
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for:
                                                      "radio7_" + item.aplnSort
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "TITLE.GLOBAL.PARALLELAPPROVAL"
                                                        )
                                                      ) +
                                                      "\n                                                            "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  : _c(
                                      "fieldset",
                                      { staticClass: "radio-items" },
                                      [
                                        _c("div", [
                                          _c("input", {
                                            staticClass: "only-sr",
                                            attrs: {
                                              type: "radio",
                                              value: "1",
                                              id: "radio1_" + item.aplSort,
                                              name: "radio_" + item.aplSort
                                            },
                                            domProps: {
                                              checked: _vm.getChecked(
                                                "1",
                                                item.aplnRole
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.getActive(
                                                  $event,
                                                  "input",
                                                  item.aplSort,
                                                  item.aplnRole
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "radio1_" + item.aplSort
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "TITLE.GLOBAL.APPROVAL"
                                                    )
                                                  ) +
                                                  "\n                                                            "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("input", {
                                            staticClass: "only-sr",
                                            attrs: {
                                              type: "radio",
                                              value: "2",
                                              id: "radio2_" + item.aplSort,
                                              name: "radio_" + item.aplSort
                                            },
                                            domProps: {
                                              checked: _vm.getChecked(
                                                "2",
                                                item.aplnRole
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.getActive(
                                                  $event,
                                                  "input",
                                                  item.aplSort,
                                                  item.aplnRole
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "radio2_" + item.aplSort
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "TITLE.GLOBAL.CONSENT"
                                                    )
                                                  ) +
                                                  "\n                                                            "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("input", {
                                            staticClass: "only-sr",
                                            attrs: {
                                              type: "radio",
                                              value: "9",
                                              id: "radio9_" + item.aplSort,
                                              name: "radio_" + item.aplSort
                                            },
                                            domProps: {
                                              checked: _vm.getChecked(
                                                "9",
                                                item.aplnRole
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.getActive(
                                                  $event,
                                                  "input",
                                                  item.aplSort,
                                                  item.aplnRole
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "radio9_" + item.aplSort
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "TITLE.GLOBAL.NOTIFICATION"
                                                    )
                                                  ) +
                                                  "\n                                                            "
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    ),
                                _vm._v(" "),
                                _c("span", [
                                  _c(
                                    "em",
                                    {
                                      staticClass: "user ellipsis",
                                      attrs: { title: item.enFullName }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                            " +
                                          _vm._s(item.enFullName) +
                                          "\n                                                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "em",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { title: item.enTitleName }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                            . "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "em",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { title: item.enDepartmentName }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                            " +
                                          _vm._s(item.enDepartmentName) +
                                          "\n                                                        "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "noLine" }, [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.OPINION"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.approvalOption,
                          expression: "approvalOption"
                        }
                      ],
                      staticClass: "text_textarea w100p",
                      domProps: { value: _vm.approvalOption },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.approvalOption = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine mt-0" }, [
              _c("div", { staticClass: "btn_right text-right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")) +
                        "\n                            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("BUTTON.APPROVAL.POPUP.APPROVE")) +
                        "\n                            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154px" } }),
      _vm._v(" "),
      _c("col", { staticClass: "*" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0200d508", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0200d508","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/common/popup/ApprovalPopup.vue
// module id = ZFtN
// module chunks = 0